import client from "../../api/client";
import TApiResult from "../../types/api/TApiResult";
import { AxiosError } from "axios";
import getErrorProperty from "./config/getErrorProperty";
import { getAuth } from "firebase/auth";
import { GetAllCommentsResponse } from "../../api/board_comment";

type TApiFetchBoardComment = {
  board_id: number;
  limit: number;
  next_cursor?: string | null;
  parent_id?: number
}

export type TApiAllCommentsResult = {
  result?: GetAllCommentsResponse;
};

export const fetchBoardComments = async ({board_id, limit, next_cursor, parent_id}: TApiFetchBoardComment ): Promise<TApiResult & TApiAllCommentsResult> => {
  const query = {
    query :  { board_id, limit , next_cursor, parent_id }
  }; 

  const auth = getAuth();
  const token = await auth.currentUser?.getIdToken();
  const authHeader = { headers: { Authorization: `Bearer ${token}` } };
  return await client()
    .board_comment.get({ ...query, ...authHeader })
    .then((res) => {
      return {
        isSuccess: true,
        status: 200,
        message: "",
        result: res.body,
      };
    })
    .catch((e: AxiosError) => {
      const { status, message } = getErrorProperty(e, "fetchBoardComments");
      return {
        isSuccess: false,
        status: status,
        message: message,
      };
    });
};
